<template>
  <v-container>
    <v-layout row wrap>
      <template v-if="isLoading">
        <v-flex xs12 text-xs-center>
          <h1>Processing Payment...</h1>
        </v-flex>
        <v-flex xs12 text-xs-center>
          <v-progress-circular
            size="75"
            width="5"
            color="accent"
            class="ma-5"
            indeterminate
          />
        </v-flex>
      </template>
      <template v-else>
        <v-flex xs12 text-xs-center>
          <h1>Redirecting...</h1>
        </v-flex>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    isLoading: false
  }),
  mounted: async function () {
    // Mark activity before starting anything else
    this.isLoading = true

    // Valid actions are 'approve' or 'cancel', and they're relevant only if
    // we're returning from a PayPal subscription process. So, we want to make
    // sure that we've actually come from PayPal.
    if (this.$route.query.token === undefined) {
      return this.$router.push('/')
    }

    // See what we need to do
    switch (this.$route.params.action) {
      case 'approve':
        return this.axios.post('/invoices/payments/paypal/approval/' + this.$route.query.token)
          .catch(this.$root.apiErrorHandler(() => {
            this.isLoading = false
            return true // show our standard error message
          }))
          .finally(() => {
            this.$router.push('/subscriptions')
          })
      case 'cancel':
        this.isLoading = false
        return this.$router.push('/subscriptions')
    }
  }
}
</script>
